import DepoEventList from './DepoEventList';

export default DepoEventList;
